import React from 'react';
// import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Typography, Link, Box, Stack} from 'views/components';

const NavbarLogo = () => {
  return (
    <Stack
      direction={'row'}
      spacing={1}
      alignItems={'center'}
    >
      <Box
        component="img"
        src="/logo/quilt-icon.png"
        alt="Quilt Icon"
        sx={{
          width: '2.4rem', // adjust as needed
          height: '2.4rem', // maintains aspect ratio
        }}
      />
      <Link
        href='/'
        underline='none'
      >
        <Typography
          sx={{
            'color': 'orange.main',
            'fontWeight': 600,
            'fontSize': '1.8rem',
            'display': 'inline-block',
          }}
        >
          CareQuilt
        </Typography>
      </Link>
    </Stack>
  );
};

NavbarLogo.propTypes = {
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarLogo));
